import React from 'react';
import { createRoot } from 'react-dom/client';
import LocationSidebar from '../customer_pages/_location-sidebar/location-sidebar';
import { useAppStateStore } from 'stores/useAppStateStore';

document.body.insertAdjacentHTML(
  'beforeend',
  '<div id="location-sidebar"></div>',
);

createRoot(document.getElementById('location-sidebar')).render(
  <LocationSidebar />,
);

document
  .querySelectorAll('header a[href$="/store-finder"]')
  .forEach((anchor) => {
    anchor.addEventListener('click', function (e) {
      e.preventDefault();

      useAppStateStore.setState((state) => ({
        ...state,
        openSidebar: true, // This will trigger the sidebar to open
      }));
    });
  });
